<script setup>
import { computed } from 'vue';

const props = defineProps({
  sent: { type: Number, default: 0 },
  delivered: { type: Number, default: 0 },
  // 'confirmed' => real receipts (emerald), 'estimated' => assumed sent=delivered (amber)
  tone: { type: String, default: 'confirmed' },
});

const rate = computed(() =>
  props.sent > 0 ? Math.min(100, (props.delivered / props.sent) * 100) : 0
);

const fillClass = computed(() =>
  props.tone === 'estimated' ? 'bg-amber-400' : 'bg-emerald-500'
);

const fmtRate = computed(() => `${rate.value.toFixed(1)}%`);
const countLabel = computed(
  () =>
    `${props.delivered.toLocaleString('pt-BR')} / ${props.sent.toLocaleString('pt-BR')}`
);
</script>

<template>
  <div class="flex flex-col gap-1 w-full">
    <div class="w-full h-2 bg-n-alpha-3 rounded-full overflow-hidden">
      <div
        class="h-2 rounded-full transition-all duration-500"
        :class="fillClass"
        :style="{ width: `${rate}%` }"
      />
    </div>
    <div class="flex items-center justify-between text-xs text-n-slate-9">
      <span>{{ countLabel }}</span>
      <span class="font-medium text-n-slate-11">{{ fmtRate }}</span>
    </div>
  </div>
</template>
